"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SamplePageCreatorPage_1 = require("./SamplePageCreatorPage");
require("./SamplePageCreator.ng.html");
exports.default = angular.module("qwilr.", ["ui.router"]).config([
    "$stateProvider",
    function ($stateProvider) {
        $stateProvider.state("sample-page-creator", {
            url: "/sample-page-creator/:pageSource/:linkSecret",
            templateUrl: "SamplePageCreator/SamplePageCreator.ng.html",
            controller: function ($scope, $rootScope, $stateParams, $state) {
                var di = $rootScope.di.child();
                var linkSecret = $stateParams.linkSecret, pageSource = $stateParams.pageSource;
                var onPageCreated = function (pageId) {
                    $state.go("project", { id: pageId }, { location: "replace" });
                };
                $scope.ui = di.get("mountReactComponent")(react_1.default.createElement(SamplePageCreatorPage_1.SamplePageCreatorPage, { linkSecret: linkSecret, pageSource: pageSource, onPageCreated: onPageCreated }));
            },
        });
    },
]);
